import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';

const init = async (parent) => {
  return new Promise((resolve) => {
    const swiperTestimonials = document.querySelectorAll('.swiper-testimonials');

    swiperTestimonials.forEach((swiperEl, index) => {
      const section = swiperEl.closest('.section');

      const sw = new Swiper(swiperEl, {
        modules: [Navigation, Pagination],
        watchOverflow: true,
        autoHeight: true,
        pagination: {
          el: section.querySelector('.swiper-pagination'),
          type: 'bullets',
          clickable: true,
        },
        navigation: {
          nextEl: section.querySelector('.swiper-button-next'),
          prevEl: section.querySelector('.swiper-button-prev'),
        },
        grabCursor: true,
        speed: swiperEl.dataset.speed ?? 640,
        slidesPerView: 1
      });
    });

    return resolve('Testimonials component loaded');
  });
};

export { init };
